import * as React from 'react'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'

import Icon from '../../ui/Icon/Icon'
import AccessibleForm from '../../accessibility/AccessibleForm/AccessibleForm'
import ContactUsForm from '../ContactUsForm/ContactUsForm'

import MoreHeaderParticles from '../../../assets/img/more-header-particles.svg'

import media from '../../../services/generateMediaQueries'
import validateContactUs from '../../../services/validation/ContactUs'

const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border: none;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  outline: none;
  opacity: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  & > .react-reveal {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }
`

const ModalContentWrapper = styled.div`
  overflow: auto;
  max-height: 100vh;
  width: 100%;

  ${media.lessThan('small')`
    height: 100vh;
  `}
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: #ffffff;
  border: 0;
  background-color: transparent;
  top: 1.7rem;
  right: 1.7rem;
  font-size: 25px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 3rem auto;
  width: 100%;
  max-width: 700px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;

  ${media.lessThan('small')`
    margin: 0;
    // height: 100%;
    max-width: unset;
    mask-image: unset;
    border-radius: 0;
  `}
`

const Header = styled.div`
  flex: 0 0 auto;
  padding: 3rem;
  background: var(--color-primary);
  background-image: url('${MoreHeaderParticles}');
  background-size: cover;
  background-repeat: no-repeat;

  ${media.lessThan('small')`
    height: 87px;
    padding: 1.7rem;
    position: fixed;
    width: 100%;
    z-index: 1;
  `}
`

const Title = styled.h3`
  color: white;
  font-size: 2rem;
  font-weight: var(--font-weight-boldest);
  line-height: 2rem;
  margin: 0;
  text-transform: uppercase;
`

const Content = styled.div`
  flex: 1 1 auto;
  background: #ffffff;
  padding: 2rem 3rem;
  overflow: auto;

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 1.5rem;
  }

  & .messageContent {
    position: relative;
  }

  & .messageContent > p {
    color: var(--color-primary);
    margin-bottom: 1.2rem;
  }

  ${media.lessThan('small')`
    padding: 1.5rem;
    margin-top: 87px;
  `}
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function ContactUsModal(props) {
  const {
    handleClose,
    show,
    loading,
    onClose,
    children,
    CloseButton,
    zIndex,
    onSubmit,
    shouldCloseOnOverlayClick = true,
    ...restProps
  } = props

  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      {...restProps}
    >
      <ModalContentWrapper>
        <ModalContent>
          <Header>
            <Title>Contact Us</Title>
            <DefaultCloseButton zIndex={zIndex} onClick={onClose}>
              <Icon name="x" />
            </DefaultCloseButton>
          </Header>
          <Content>
            <AccessibleForm
              enableReinitialize
              initialValues={{
                isAcceptTerms: false,
                isCheckSubs: false,
              }}
              onSubmit={onSubmit}
              method="post"
              action="/a/contact-us"
              validate={validateContactUs}
              component={ContactUsForm}
              isContactUs
            />
          </Content>
        </ModalContent>
      </ModalContentWrapper>
    </StyledReactModal>
  )
}

ContactUsModal.defaultProps = {}

ContactUsModal.propTypes = {}

export default ContactUsModal
